export default "/_next/static/videos/369b8ced38526803f66a07af00683747.mp4";